module.exports = __webpack_public_path__ + "img/20_96.3f160a6c.png";